import React from 'react';
import { useLocation } from 'react-router-dom';
import DeployThematicPackage from '../components/business/eshop/DeployThematicPackage';
import DeployedThematicPackages from '../components/business/eshop/DeployedThematicPackages';
import EshopPagesNavigation from '../components/business/eshop/EshopPagesNavigation';
import AppLoader from '../components/basic/AppLoader';
import { useItems } from '../hooks/atoms/items-hook';
import CollectionKeys from '../hooks/molecules/collection-keys';

export const EshopPageCtx = React.createContext({});

function EshopPageProvider(props) {
  const ctx = {
  };

  return (
    <EshopPageCtx.Provider value={ ctx }>
      {props.children}
    </EshopPageCtx.Provider>
  );
}

export const eshopPages = {
  NEW_DEPLOYMENT: 'deploy',
  DEPLOYED_THEMATIC_PACKAGES: 'deployed-thematic-packages',
};
function EshopPage() {
  const location = useLocation();

  const { search } = location;
  const activePage = new URLSearchParams(search).get('page');

  const {
    items: deployedThematicPackages,
    itemsLoading: deployedthematicPackagesLoading,
    pagination: {
      page: deployedPage,
      limit: deployedLimit,
      count: deployedCount,
      setPage: handleChangePage,
      setLimit: handleChangeRowsPerPage,
    },
  } = useItems(CollectionKeys.THEMATIC_PACKAGES, { filterQuery: { eshop_deployed: true } });

  const {
    items: notDeployedThematicPackages,
    itemsLoading: notDeployedThematicPackagesLoading,
  } = useItems(CollectionKeys.THEMATIC_PACKAGES, { filterQuery: { eshop_deployed: false, _limit: -1 } });

  if (deployedthematicPackagesLoading || notDeployedThematicPackagesLoading) { return <AppLoader />; }

  return (
    <EshopPageProvider>
      <EshopPagesNavigation
        page={ activePage }
        entries={ (deployedCount) }
      />
      {
        activePage === eshopPages.NEW_DEPLOYMENT && <DeployThematicPackage notDeployedThematicPackages={ notDeployedThematicPackages } />
      }
      {
        activePage === eshopPages.DEPLOYED_THEMATIC_PACKAGES && (
          <DeployedThematicPackages
            deployedThematicPackages={ deployedThematicPackages }
            paginationProps={ { page: deployedPage, limit: deployedLimit, count: deployedCount, handleChangePage, handleChangeRowsPerPage } }
          />
        )
      }
      {
        !Object.values(eshopPages).includes(activePage) && <div>Page not found</div>
      }
    </EshopPageProvider>
  );
}

export default EshopPage;
